<template>
  <div class="container mt-5">
    <h2>Crear Plan de Cultivo</h2>

    <!-- Formulario para datos generales del plan -->
    <form @submit.prevent="submitPlanCultivo">
      <div class="mb-3">
        <label for="objetivo" class="form-label"><font-awesome-icon :icon="['fas', 'bullseye']" /> Objetivo del Plan</label>
        <input type="text" v-model="plan.objetivo" class="form-control" id="objetivo" required />
      </div>
  
      <div class="row">
        <div class="col-md-6">
          <label for="objetivo_cumplido" class="form-label">¿Objetivo Cumplido?</label>
          <select v-model="plan.objetivo_cumplido" class="form-select" id="objetivo_cumplido" required>
            <option :value="true">Sí</option>
            <option :value="false">No</option>
          </select>
        </div>
        <div class="col-md-6">
          <label for="planificado_por" class="form-label">Seleccione quien planifica</label>
          <select v-model="plan.planificado_por" class="form-control" id="planificado_por" required>
            <option value="" disabled>Seleccione quien planifica</option>
            <option v-for="persona in personal" :key="persona.id" :value="`${persona.nombre} ${persona.legajo}`">
              {{ persona.nombre }} {{ persona.legajo }}
            </option>
          </select>
        </div>
      </div>
  
      <div class="mb-3">
        <label for="descripcion" class="form-label">Descripción del Plan</label>
        <textarea v-model="plan.descripcion" class="form-control" id="descripcion" rows="3" required></textarea>
      </div>

      <!-- Botón para enviar el formulario de datos generales -->
      <button type="submit" class="btn btn-primary mt-4">
        Crear Plan de Cultivo
      </button>
      <button type="button" class="btn btn-secondary mt-4" @click="$emit('cancelar')">Cancelar</button>
    </form>
  </div>
</template>

<script>
import axios from '@/axios';
import emitter from '@/mitt';

export default {
  data() {
    return {
      plan: {
        objetivo: '',
        objetivo_cumplido: false,
        planificado_por: '',
        descripcion: '',
      },
      clubActual: this.$store.getters.getClubActual,
      personal: [],
    };
  },
  created() {
    this.fetchPersonal();
  },
  methods: {
    async fetchPersonal() {
      try {
        const response = await axios.get('/api/personal', {
          params: {
            club_id: this.clubActual.id
          }
        });
        this.personal = response.data;

      } catch (error) {
        console.error('Error al obtener la lista de personal:', error);
      }
    },
    async submitPlanCultivo() {
      try {
        const response = await axios.post('/api/planes_cultivo', {
          form: this.plan,
          club_id: this.clubActual.id
        });
        alert('Plan de cultivo creado con éxito');
        emitter.emit('cambiar-vista', 'listar');
        this.resetForm();
        this.$emit('plan-creado', response.data);
      } catch (error) {
        console.error('Error al crear el plan de cultivo:', error);
        if (error.response?.status === 400 && error.response.data?.error) {
          alert(`Error: ${error.response.data.error}`);
        } else {
          alert('Hubo un error al crear el plan de cultivo');
        }
      }
    },
    resetForm() {
      this.plan = {
        objetivo: '',
        objetivo_cumplido: false,
        planificado_por: '',
        descripcion: '',
      };
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 900px;
  background-color: #f8f9fa;
  border-radius: 10px;
  padding: 2rem;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

button {
  margin-top: 10px;
  font-size: 1.1rem;
  padding: 0.75rem 1.5rem;
  border-radius: 30px;
  background-color: var(--app-primary);
  color: #fff;
  border: none;
  transition: background-color 0.3s ease;
}

button:hover {
  background-color: darken(var(--app-primary), 10%);
}
</style>
